import { SelectBox, useApi } from "lcm-iot-commons";

type Props = {
  initialValues: {
    status?: $TSFixMe;
  };
};

export default function ProductStatusSelect(props: Props) {
  const api = useApi();
  const { initialValues } = props;
  const { data, isLoading } = api.get.useQuery("/product/statuses", {
    include: "tenant",
  });

  const productStatuses = data
    ? (data as $TSFixMe).product_statuses?.map((productStatus: $TSFixMe) => ({
        id: productStatus.id,
        name: productStatus.name,
        code: productStatus.code,
        description: productStatus.description,
        tenantPublic: productStatus.tenant?.public,
        tenantName: productStatus.tenant?.name,
      }))
    : [];
  initialValues.status =
    initialValues.status ??
    productStatuses?.find((status: $TSFixMe) => status.code === "active");

  return isLoading ? null : (
    // @ts-expect-error TS(2322) FIXME: Type '{ options: never[]; labelKey: string; api: a... Remove this comment to see the full error message
    <SelectBox {...props} options={productStatuses} labelKey="name" />
  );
}
